import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useClientContact, ClientContact } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ClientContact>
      useData={useClientContact}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
